<template>
    <div class="contre-right">
        <div v-if="!isShowBridge && $G_DEVICE_CFG.isBridge" class="bridge-text">
            <p>Bridge mode this feature page is not available</p> 
            <p class="bridge-text-tips">Tips:You can turn off Filink or wireless relay switch or restore factory settings, restore the device to router mode.</p>
        </div>
        <component  v-else v-bind:is="componentId"></component>
    </div>    
</template>

<script>
import Home from '@/views/home/home.vue'
export default {
    components: {
        Home
    },
    props:['path','componentName','isShowBridge'],
    computed: {
        componentId () {
            if(this.path != 'home')
                return require(`@/views/${this.path}/${this.componentName}`).default
            else
                return
        }
    },
}
</script>

<style>
.contre-right{
    background-color: #ffffff;
    padding: 10px 50px 50px 50px;
    min-height: 1010px;

}

</style>